import { render, staticRenderFns } from "./CreateShareTransaction.vue?vue&type=template&id=2bd54772&"
import script from "./CreateShareTransaction.vue?vue&type=script&lang=js&"
export * from "./CreateShareTransaction.vue?vue&type=script&lang=js&"
import style0 from "./CreateShareTransaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports